export default __webpack_public_path__ + "static/media/unionpay.51253733.svg";